module.exports = __webpack_public_path__ + "img/chongzhou3.39e3551f.png";